export const theme = {
  palette: {
    mode: 'dark',
    // Yellow
    primary: {
      main: '#F4E356',
      contrastText: '#000'
    },
    // Magenta
    secondary: {
      main: '#7E4AEB',
      contrastText: '#000'
    },
    // Gray (for Price Widget)
    third: {
      main: '#D0D2DC',
      contrastText: '#000'
    },
    // Black (for ProductionStatWidget - Solar)
    forth: {
      main: '#1A2026',
      dark: '#000', // TODO: What color?
      contrastText: '#FFF'
    },

    background: {
      default: '#101820',
      paper: '#101820',
    },

    grey: {
      100: '#F0F0F0',
      200: '#D9D9D9',
      300: '#C3C3C3',
      400: '#A3A3A3',
      500: '#9FA1AB',
      600: '#737373',
      700: '#D0D2DC',
      800: '#373D42',
      900: '#1A2026',
    },

    iconColor: {
      main: ''
    },

    // State colors
    error: {
      main: '#BB4817',
      light: '#F15B1A',
    },
    success: {
      main: '#009467',
      light: '#09E7A4',
    },
    warning: {
      main: '#C1B230',
      light: '#F4E356',
    },

    // Panel
    panelBackground: {
      main: '#1A2026'
    },
    panelText: {
      main: '#F0F0F0'
    },

    // Stats
    statsBackground: {
      main: '#1A2026'
    },
    statsHistoryBackground: {
      main: '#1A2026'
    },
    statsText: {
      main: '#FFF'
    },

    // Chart
    chartText: {
      main: '#FFF'
    },
    chartMidpointLine: {
      main: 'rgba(255, 255, 255, 0.5)'
    },

    // Other backgrounds
    radioSelectorBackground: {
      main: '#1A2026'
    },
    configBackground: {
      main: '#1A2026'
    },
    debugBackground: {
      main: 'rgba(255,255,255,0.3)'
    },

    // Device
    deviceOnline: {
      main: '#09E7A4',
    },

    // Others
    toggleControl: {
      main: '#7E4AEB',
    },
    dimColor: {
      main: 'rgba(244, 227, 86, 0.5)',
    },
    selectedChip: {
      main: '#7E4AEB'
    }
  },

  // Custom boxShadow property (outside palette to avoid MUI color parsing)
  boxShadow: {
    main: '0px 4px 35px rgba(0, 0, 0, 0.25)',
  },

  typography: {
    fontFamily: 'Inter',
    // Title in the top of the page.
    h1: {
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      letterSpacing: '0.1em',
      textTransform: 'uppercase',

      color: '#FFFFFF'

    },
    // Titles inside the page with short underline.
    h2: {
      fontSize: '1rem',
      color: '#f0f0f0',
      fontWeight: 400,
      textTransform: 'uppercase',
      lineHeight: '1.1875rem',
      letterSpacing: '0.1em'
    },
    h3: {
      fontSize: 18,
    },
    h4: {
      fontSize: 16,
    },
    h5: {
      fontSize: 12,
    },
    // Common sentences in the page.
    body1: {
      color: '#A3A3A3',
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '150.02%'
    }
  },

  components: {
    // Default button.
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#000',
          backgroundColor: '#F4E356',
          height: '2.75rem',
          borderRadius: '0.75rem',
          padding: '1rem 2rem 0.9rem 2rem',
          fontWeight: '600',
          fontSize: '1rem',
          letterSpacing: '0.1rem',
          '&.Mui-disabled': {
            backgroundColor: '#373D42 !important',
            color: '#1A2026'
          },
          '&.MuiButton-outlined': {
            backgroundColor: '#737373',
            color: 'black',
            borderColor: '#737373'
          },
          '@media (max-width: 900px)': {
            '&:hover': {
              backgroundColor: '#F4E356',
            }
          },
        },
      },
    },

    // Default input label.
    MuiInputLabel: {
      styleOverrides: {
        root: {
          position: 'relative',
          transform: 'translateY(-0.4rem)',
          backgroundColor: 'transparent',
          color: '#999',
          '&.Mui-focused': {
            color: '#7E4AEB'
          },
          '&.Mui-error': {
            color: '#F15B1A'
          }
        },
      },
    },

    // Default text field.
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #373D42 inset!important',
            WebkitTextFillColor: 'rgba(255,255,255,0.7)!important',
          },
          '&:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0 100px #373D42 inset!important',
            WebkitTextFillColor: 'rgba(255,255,255,0.7)!important',
          }
        },
        root: {
          color: '#A3A3A3',
          backgroundColor: 'rgba(255,255,255,0.1)',
          borderRadius: '0.375rem',
          fontSize: '1rem',
          fontWeight: 400,
          '&.Mui-error': {
            color: '#F15B1A'
          },
          '.MuiOutlinedInput-notchedOutline legend': {
            width: 0,
          }
        },
      }
    },

    // Default helper text for input field.
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#A3A3A3',
          marginTop: '0.3rem',
          marginLeft: 0
        }
      }
    },

    // Accordion mainly used in device configuration.
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:before': {
            backgroundColor: '#101820',
          },
          borderRadius: '0.625rem',
          '&.plain': {
            border: 'none',
            backgroundColor: '#101820',
            boxShadow: 'none',
          },
        },
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          borderRadius: '0.625rem',
          color: '#F0F0F0',
          fontSize: '1rem',
          fontWeight: 400,
          paddingLeft: '0.5rem',
          '&.plain': {
            border: 'none',
            backgroundColor: '#101820',
            boxShadow: 'none',
          },
        },
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          borderRadius: '0.625rem',
          padding: '0.5rem',
          '&.plain': {
            border: 'none',
            backgroundColor: '#101820',
            boxShadow: 'none',
          },
        }
      }
    },

    // Slider
    MuiSlider: {
      styleOverrides: {
        rail: {
          color: '#F4E356',
          height: '2px',
          opacity: 1,
        },
        track: {
          border: 'none',
          color: '#F4E356',
          height: '2px',
        },
        thumb: {
          color: 'white',
        }
      }
    },

    // Radio button group
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          border: 'none',
          borderRadius: '0.25rem',
        },
        grouped: {
          padding: '0 0.7rem 0 0.7rem',
          borderRadius: '0.25rem',
          fontSize: '0.75rem',
          fontWeight: 500,
          textTransform: 'none',
          height: '2rem',
          '&:not(:last-of-type)': {
            border: 'none',
            borderRadius: '0.25rem',
          },
          '&:last-of-type': {
            borderRadius: '0.25rem',
          },
        }
      }
    },

    // Chips
    MuiChip: {
      styleOverrides: {
        root: {
          '&.selected:hover': {
            color: '#F4E356',
            backgroundColor: '#7E4AEB'
          }
        },
      }
    },

    // Custom switch.
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '.MuiSwitch-thumb': {
              backgroundColor: '#373D42'
            },
          },
          '.MuiSwitch-thumb': {
            backgroundColor: '#F8F8F8'
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          marginTop: '0.20rem',
          height: '0.5rem',
          borderRadius: '0.5rem',
          backgroundColor: '#A3A3A3',
        },
        root: {
          '&.waiting': {
            '.MuiSwitch-thumb': {
              backgroundColor: '#373D42',
              border: '2px solid #A3A3A3',
              borderTopColor: '#373D42',
            },
          },
        }
      }
    }
  },
}
